import type { FaireProductEntity } from "../../entity_types/product";

export const p_gv32jnujxb: FaireProductEntity = {
  token: "p_gv32jnujxb",
  type: "product",
  name: "Colombia, La Magdalena, 12 oz Organic Single Origin",
  brandToken: "b_3angyj4q6y",
  brandName: "Sightglass Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/9252d6935fe40cd763060908ed6cb9feb57ad8167f83cda7d3fe407c25d3feb4.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c59addcbd49b7e1c87dbd674eb1eb803d725c3130308ac23f2a3b9bcf4925ab4.png",
    "https://cdn.faire.com/fastly/b82b58d129f78ef934797c027142575053e449026c4f9295fb856d7491b635ba.png",
    "https://cdn.faire.com/fastly/ca8b01d5d93fe920b18da5054645450e7cc243bccb09f4935f81fa2a32a058c6.png",
    "https://cdn.faire.com/fastly/9ccf66ccd4b10f0cd7dd2ce43179cc5dd5c882b40a89225c905ea3b3dc126352.jpeg",
    "https://cdn.faire.com/fastly/443a70ba743c00b079f7e372b3cc355b79a72c0c0266c0829510f4a5b1cf40d5.jpeg",
    "https://cdn.faire.com/fastly/e136cb9c51e8bf15ed806bbf4ecc8f46f7650e750620a3d644182d77c7023bf9.jpeg"
  ],
  priceDollars: 12.15,
  description: "Colombia // Each time we visit Colombia, most of our time is spent traveling alongside the Magdalena River. Bound by the Andes Mountains, the river valley is home to many of our favorite regions and oldest producer relationships. We source this coffee from farms in Tolima, Huila & Nariño.\n\nCCOF Certified Organic\n\nTaste notes // Toffee, Concord Grape, and Red Apple\nRoast level // Light-Medium\nRecommended brew methods // V60, Chemex, Kalita Wave, French Press\nShelf life // All our whole bean coffees are roasted fresh to order and stamped with the roast date. We encourage selling the coffee within 60 days of the roast date for optimal freshness and flavor. If you have questions about freshness or how to brew this coffee, send us a note on here or email [redacted-email]!",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:58.702Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
